<template>
  <div id="login">
    <router-link :to="{ name: 'index'}">
      <svgicon name="logo" height="150" width="350" :original="true"></svgicon>
    </router-link>
    <p class="logo-text">GamePlan</p>
    <p v-if="error" class="error">
      {{ error }}
    </p>
    <p v-if="message" class="error">
      {{ message }}
    </p>
    <slot></slot>
    <div class="level">
      <div class="level-left digita-production">
        <svgicon class="level-item" name="shield" height="35" width="35"></svgicon>
        <p class="level-item">a Digita Security Production</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginBase',
  props: {
    error: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
  data() {
    return { };
  },
  methods: { },
};
</script>

<style lang="scss" scoped>

#login {
  height: 100vh;
  width: 400px;
  margin: 0 auto;
  // border: 3px solid $border-color;
  padding: $content-padding;


  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .login-container {
    width: 100%;

    a {
      width: 100%;
    }
  }

  a {
    width: auto;
  }

  a.button, a.img-button {
    margin-bottom: 15px;
  }

  .digita-production {
    color: $link-color;
    margin: 0 auto;
  }

  p.info {
    text-align: center;
    margin-bottom: 15px;
  }

  p.error {
    color: $attention;
    text-align: center;
    margin-bottom: .5rem;
  }

  p.logo-text {
    color: $link-color;
    margin-bottom: 10px;
    font-size: 2em;
    text-align: center;
    font-weight: 500;
    font-family: 'Avenir Next', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 500;
  }
}
</style>
